module.exports = __webpack_public_path__ + "assets/img/b3.9f8ef5fd.jpg";